const dot = require('dot-object');
const kebabCase = require('lodash/kebabCase');
const { filterPayload } = require('@ordergroove/schemas/lib/utils');

const cssKeyCase = key => `--og-${kebabCase(key)}`;

const mapCssPropToVar = styles => ([key, val]) => {
  if (key.endsWith('.unit')) return null;
  let value = val;
  if (key.endsWith('.size')) {
    const unit = styles[key.replace(/\.size$/, '.unit')];
    // if value is string ending without unit
    if (`${value}`.trim().match(/\d$/)) {
      value = `${value}${unit || 'px'}`;
    }
  }
  if (value) {
    return [cssKeyCase(key), value];
  }
  return null;
};

const mapStyles = styles => {
  const dotStyles = dot.dot(styles);
  return Object.entries(dotStyles)
    .map(mapCssPropToVar(dotStyles))
    .filter(it => it);
};

const injectCssVariables = (styles, cssSelector = 'html') => {
  const entries = mapStyles(styles);
  const fn = 'function(s,e){e.forEach(function(t){s.setProperty(t[0], t[1])})}';
  return `(${fn}(document.querySelector('${cssSelector}').style, ${JSON.stringify(entries)}));`;
};

function resolveCss(values, schema = null, cssSelector = 'html') {
  const payload = schema ? filterPayload(schema, values) : values;
  return injectCssVariables(payload, cssSelector);
}

module.exports = { injectCssVariables, mapStyles, resolveCss, cssKeyCase };
